import { getPrepayCard } from '@/graphql/queries/banking/prepay-card';
import lang from '@/lang/middleware/products/banking/prepay-cards';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  await $apolloQuery(getPrepayCard, { code: route.params.code }).then(card => {
    if ((route.params.slug !== card.slug) || (route.params.provider !== card.institution.slug)) {
      return redirect(301, app.localePath(`/compare-prepaid-credit-cards/${card.institution.slug}/${card.code}/${card.slug}/`));
    }

    store.$i18n.mergeLocaleMessage('en', lang.en);
    const fees = { purchase: card.purchase_cost, annual: card.annual_fee && card.annual_fee_cost, monthly: card.monthly_cost };
    const list = Object.keys(fees).map(feeType => {
      let fee = fees[feeType];
      let feeText = store.$i18n.t(`results.jumbotron.list.${feeType}.${fee ? 'cost' : 'free'}`, [store.$i18n.n(fee, 'currencyRound')]);
      if (feeType === 'monthly' && card.monthly_inactive_fee) {
        feeText = `${feeText} *`;
      }
      return feeText;
    }).filter(item => item);

    const description = store.$i18n.t('results.description');
    const title = [card.institution.name, card.name].join(' ');
    store.commit('products/set', card);
    store.commit('jumbotron/SET_JUMBOTRON', { list, title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/banking', '/money/'],
      ['i18n/prepay-cards', '/compare-prepaid-credit-cards/'],
      ['i18n/providers', '/compare-prepaid-credit-cards/providers/'],
      [card.institution.name, `/compare-prepaid-credit-cards/${card.institution.slug}/`, 'mobile'],
      card.name
    ]);
    store.commit('pageContent/setHead', { description, title });
  });
};
